// extracted by mini-css-extract-plugin
export default {"youtube":"youtube__QS17-"};